import React, { useEffect,useState } from 'react';
import { Accordion } from 'react-bootstrap';
import { FaAngleUp } from 'react-icons/fa';

const CustomSelectloactor = ({ options, defaultSelected, onSelect, hasicon }) => {

  console.log("defaultSelected ---------", defaultSelected);
  const [selectedOption, setSelectedOption] = useState(defaultSelected);
  const [isOpen, setIsOpen] = useState(false);

  const toggleDropdown = () => {
    console.log("sadsadasdas");
    setIsOpen(!isOpen);
  };

  const handleOptionSelect = (option) => {
    setActiveKey(null);
    setSelectedOption(option);
    setIsOpen(false);
    onSelect(option)
  };

  useEffect(() => {
    setSelectedOption(defaultSelected);
  }, [defaultSelected]);

  const [activeKey, setActiveKey] = useState(null); // closed by default


  const toggleAccordion = () => {
    setActiveKey(prev => (prev === '0' ? null : '0'));
  };



  return (
    <div className="col-12 hover-color">
      <div className="tab-container tab-club-fitting mt-1">
        <div className="tab-box-section p-0">
          <div className="accordion-section">
            <Accordion activeKey={activeKey}  >
              <Accordion.Item eventKey="0" className="results-accordion">
                <div className="gs_b p-0 club-fitting-card accordion-item">
                  <div className="accordion_card_view" id="lesson_card_1">
                    <Accordion.Header onClick={toggleAccordion}>
                      <div className="gab_title">
                        <div className="text-left selected-option-drop px-0">
                          <div className="selected-option-text d-flex align-items-center" style={{ fontSize: "18px", fontWeight: "800" }}>

                            {
                              hasicon && (
                                <img src={selectedOption.icon} alt={selectedOption.label} className="selected-flag" style={{ height: "30px", width: "30px", borderRadius: "50%", objectFit: "cover" }} />
                              )
                            }
                            {/*  */}
                            <strong className='ms-3 mt-1'>{selectedOption.label}</strong>
                          </div>
                        </div>
                        <div className="collapsed">
                          <FaAngleUp size={18} color='#ffffff' style={{ cursor: "pointer", marginLeft: "auto" }} />
                        </div>
                      </div>
                    </Accordion.Header>
                  </div>
                  <Accordion.Body className="results-accordion-body pt-0 px-3">
                    <div className="accordion-dropdown-options">
                      {options.map((option, index) => (
                        <div
                          key={index}
                          className="accordion-option-item d-flex align-items-center px-0 py-3 "
                          onClick={() => handleOptionSelect(option)}
                          style={{ cursor: "pointer" }}
                        >
                          {
                            hasicon && (
                              <img src={option.icon} alt={option.label} className="option-flag" style={{ height: "30px", width: "30px", borderRadius: "50%", objectFit: "cover" }} />
                            )
                          }
                          {/*  */}
                          <span style={{ color: "#ffffff", fontSize: "18px", fontWeight: "700" }} className='ms-3 mt-1'>{option.label}</span>
                        </div>
                      ))}
                    </div>
                  </Accordion.Body>
                </div>
              </Accordion.Item>
            </Accordion>
          </div>
        </div>
      </div>
      <style>
        {`
            .hover-color .accordion-option-item.px-3.py-4:hover {
                background-color: #99ea24;
                color: #0000000;
                border-radius: 20px;
            }
        `}
      </style>
    </div>
  );
};

export default CustomSelectloactor;
